import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
  Button,
} from "@mui/material";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import {
  LogButton,
  ViewButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch, useSelector } from "react-redux";
import Loader3D from "../../../../../components/Loader/Loader3D";
import {
  getSessionLogCrm,
  getSessionLogCro,
} from "../../../../../redux/features/CRDslice";
import { useNavigate } from "react-router-dom";
import { ro } from "date-fns/locale";

const SessionLogCRO = ({ data, rowData, courseEnrollmentId, crm }) => {
  const [open, setOpen] = useState(false);

  const { loading, sessionLogCro } = useSelector((state) => state.crd);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const headers = [
    "Sl No",
    "Subject",
    "Class Per Week",
    "Fee Per Session",
    "Trainer Name",
    "Trainer Payment Per Session",
    "Session Duration",
    "Trainer Assignment Status",
    "Action",
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 13,
      border: "1px solid #ccc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      border: "1px solid #ccc",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  useEffect(() => {
    if (open) {
      dispatch(getSessionLogCro(courseEnrollmentId));
    }
  }, [open]);

  const handleClick = useCallback(() => {
    navigate(
      `/my-workspace/attendance-mark?admissionNo=${rowData.admn_no}&course=${rowData.course_name}&studentName=${rowData.student_name}`
    );
  });

  const handleWorkspace = (trainer_assignment_id) => {
    const url = `https://workspace.teaminterval.net/employee/cro_mark_attendance/${trainer_assignment_id}`;
    window.open(url, "_blank");
  };

  return (
    <GlobalDialog
      title="Session Log"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={"lg"}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)} disabled={crm}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <GlobalWrapper>
              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                spacing={1}
                paddingBottom={3}
              >
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Admission No : {rowData.admn_no}
                </Box>
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Student Name : {rowData.student_name}
                </Box>
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Course : {rowData.course_name}
                </Box>
              </Stack>
              <Paper
                sx={{
                  margin: 1,
                  borderRadius: 4,
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #ccc",
                    borderCollapse: "collapse",
                    marginTop: 2,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {headers.map((header, index) => (
                        <StyledTableCell key={index} align="center">
                          {header}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sessionLogCro?.map((row) => (
                      <StyledTableRow key={row.sl_no}>
                        <StyledTableCell align="center">
                          {row.sl_no}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.subject_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.class_per_week}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.fee_per_session}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trainer_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trainer_payment_per_session}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.session_duration}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trainer_assignment_status === "true" ? (
                            <Chip
                              label="Active"
                              size="small"
                              color="success"
                              variant="outlined"
                            />
                          ) : (
                            <Chip
                              label="Inactive"
                              size="small"
                              color="error"
                              variant="outlined"
                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trainer_assignment_status === "true" ? (
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleWorkspace(row.trainer_assignment_id)
                              }
                            >
                              Mark Attendance
                            </Button>
                          ) : (
                            <Button
                              size="small"
                              disabled
                              variant="contained"
                              color="error"
                            >
                              Mark Attendance
                            </Button>
                          )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </GlobalWrapper>
          )}
        </>
      }
    />
  );
};

export default SessionLogCRO;
